import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';
import { CommonUtilityService } from 'src/app/core/services/commonUtility.service';
import { OrderService } from 'src/app/core/services/order.service';
import { ProductService } from 'src/app/core/services/product.service';
import { ChartType } from '../dashboard/dashboard.model';
import { BestSelling } from '../dashboard/data';

@Component({
  selector: 'app-product-dashboard',
  templateUrl: './product-dashboard.component.html',
  styleUrls: ['./product-dashboard.component.scss']
})
export class ProductDashboardComponent implements OnInit {

  constructor(
    private productService: ProductService,
    private ccs: CommonCommunicationService,
    private orderService: OrderService,
    private commonUtilityService: CommonUtilityService,
    private router:Router
  ) { }

  statData: any[] = []
  analyticsChart!: ChartType;
  BestSelling: any;
  basicColumnChart: any;
  activeShopId: any
  dateRange: any
  startDate: any = ''
  endDate: any = ''
  showClearFilterBtn: boolean = false
  prodViewGraphDate: any
  prodViewGraphSum: any
  productViewGhraph: any
  topProducts:any[] =[]
  filter:any
  showEmpty: any = false
  modulePermission: any = {
    is_delete: true,
    is_write: true,
    is_update: true,
    is_view: true,
  }
  ngOnInit(): void {
    this.ccs.getModuleList().subscribe(res => {
      if (res) {
        this.modulePermission = this.commonUtilityService.setModulePermission(res, "Product Performance")
        if (!this.modulePermission.is_view) {
          this.router.navigateByUrl('/auth/login')
        } 
      }
    })
    this.ccs.getActiveShopId().subscribe(res => {
      if (res) {
        this.activeShopId = res
        // this.fetchData()
        this.dateFilter('monthly')
      }
    })
    this._analyticsChart('["--vz-primary", "--vz-primary", "--vz-danger"]');
    this._basicColumnChart('["--vz-success", "--vz-gray-300"]');
  }

  fetchData() {
    this.statData = []
    this.BestSelling = BestSelling;
    this.getTotalProduct()
    this.getTotalCollection()
    this.getTopCategoryBySale()
    this.getProductViewsGraph()
    this.getTotalViews()
    this.getAvgViews()
    this.getTopProducts()
    this.getTotalBrand()
  }

  getTotalProduct() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.productService.getTotalProduct(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL PRODUCT',
        value: res.totalProducts,
        icon: 'bx bxs-shopping-bags',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }
  getTotalCollection() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.productService.getTotalCollection(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL COLLECTION',
        value: res.totalCollections,
        icon: 'ri-checkbox-multiple-line',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }
  getTopCategoryBySale() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.orderService.getTopCollection(payload).subscribe(res => {
      this.statData.push({
        title: 'TOP CATEGORY',
        value: res.length,
        icon: ' bx bx-category-alt',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }
  getTotalViews() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.productService.getTotalViews(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL PRODUCT VIEWS',
        value: res.totalProductViews,
        icon: ' ri-product-hunt-line',
        //   persantage: '29.08',
        //   profit: 'up'
      },
        {
          title: 'TOTAL COLLECTION VIEWS',
          value: res.totalCollectionViews,
          icon: 'bx bx-equalizer',
        })
    })
  }
  getAvgViews() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.productService.getAverageViews(payload).subscribe(res => {
      let avgCollection = parseFloat(res.avgViewsPerCollection).toFixed(2)
      let avgProduct = parseFloat(res.avgViewsPerProduct).toFixed(2)
      this.statData.push({
        title: 'AVERAGE PRODUCT VIEWS',
        value: avgProduct,
        icon: ' ri-product-hunt-line',
        //   persantage: '29.08',
        //   profit: 'up'
      },
        {
          title: 'AVERAGE COLLECTION VIEWS',
          // value: res.avgViewsPerCollection,
          value: avgCollection,
          icon: 'bx bx-equalizer',
        })
    })
  }

  getProductViewsGraph() {
    let payload = {
      "shopId": "6347c37638a80c2accaaa30c",
      "startDate": "",
      "endDate": ""
    }
    this.productService.getProductViewsGraph(payload).subscribe(res => {
     

      let prodView = res
      let sumList = []
      let dateList = []
      for (let i = 0; i < prodView.length; i++) {
        let date = prodView[i]._id.date + '/' + prodView[i]._id.month + '/' + prodView[i]._id.year
        dateList.push(date)
        sumList.push(prodView[i].sum)
      }
      this.prodViewGraphDate = dateList
      this.prodViewGraphSum = sumList
      this._productViewChart('["--vz-primary", "--vz-gray-300"]');
    })
  }

  getTopProducts() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.orderService.getTopProducts(payload).subscribe(res => {
      this.topProducts = res
      if (this.topProducts.length) {
        this.showEmpty = false
      }else{
        this.showEmpty = true
      }
    })
  }

  dateFilter(type:any){
    this.filter = type
    this.endDate = new Date()
    let date = new Date
    
    switch(type){
      case 'yearly':
        date.setFullYear(date.getFullYear() - 1);
        this.startDate = date
        this.fetchData()
        break
      case 'monthly':
        date.setMonth(date.getMonth() - 1);
        this.startDate = date
        this.fetchData()
        break
      case 'weakly':
        date.setDate(this.endDate.getDate() - 7);
        this.startDate = date
        this.fetchData()
        break
      case 'daily':
        date.setDate(this.endDate.getDate() - 1);
        this.startDate = date        
        this.fetchData()
        break
    }
  }

  private _productViewChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.productViewGhraph = {
      series: [
        //   {
        //   name: 'Last Year',
        //   data: [25.3, 12.5, 20.2, 18.5, 40.4, 25.4, 15.8, 22.3, 19.2, 25.3, 12.5, 20.2]
        // }, 
        {
          name: 'Current Year',
          // data: [36.2, 22.4, 38.2, 30.5, 26.4, 30.4, 20.2, 29.6, 10.9, 36.2, 22.4, 38.2]
          data: this.prodViewGraphSum
        }],
      chart: {
        type: 'bar',
        height: 306,
        stacked: true,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontWeight: 400,
        fontSize: '8px',
        offsetX: 0,
        offsetY: 0,
        markers: {
          width: 9,
          height: 9,
          radius: 4,
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      grid: {
        show: false,
      },
      colors: colors,
      xaxis: {
        // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        categories: this.prodViewGraphDate,
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: ''
        },
      },
      fill: {
        opacity: 1

      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            // return "$ " + val + " thousands"
            return val
          }
        }
      }
    };
  }

  private _analyticsChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.analyticsChart = {
      chart: {
        height: 370,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "straight",
        dashArray: [0, 0, 8],
        width: [2, 0, 2.2],
      },
      colors: colors,
      series: [{
        name: 'Orders',
        type: 'area',
        data: [34, 65, 46, 68, 49, 61, 42, 44, 78, 52, 63, 67]
      }, {
        name: 'Earnings',
        type: 'bar',
        data: [89.25, 98.58, 68.74, 108.87, 77.54, 84.03, 51.24, 28.57, 92.57, 42.36,
          88.51, 36.57]
      }, {
        name: 'Refunds',
        type: 'line',
        data: [8, 12, 7, 17, 21, 11, 5, 9, 7, 29, 12, 35]
      }],
      fill: {
        opacity: [0.1, 0.9, 1],
      },
      labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
      markers: {
        size: [0, 0, 0],
        strokeWidth: 2,
        hover: {
          size: 4,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      grid: {
        show: true,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        padding: {
          top: 0,
          right: -2,
          bottom: 15,
          left: 10,
        },
      },
      legend: {
        show: true,
        horizontalAlign: "center",
        offsetX: 0,
        offsetY: -5,
        markers: {
          width: 9,
          height: 9,
          radius: 6,
        },
        itemMargin: {
          horizontal: 10,
          vertical: 0,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "30%",
          barHeight: "70%",
        },
      },
    };
  }

  // Chart Colors Set
  private getChartColorsArray(colors: any) {
    colors = JSON.parse(colors);
    return colors.map(function (value: any) {
      var newValue = value.replace(" ", "");
      if (newValue.indexOf(",") === -1) {
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
        if (color) {
          color = color.replace(" ", "");
          return color;
        }
        else return newValue;;
      } else {
        var val = value.split(',');
        if (val.length == 2) {
          var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  }

  /**
 * Basic Column Charts
 */
  private _basicColumnChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.basicColumnChart = {
      series: [{
        name: 'Last Year',
        data: [25.3, 12.5, 20.2, 18.5, 40.4, 25.4, 15.8, 22.3, 19.2, 25.3, 12.5, 20.2]
      }, {
        name: 'Current Year',
        data: [36.2, 22.4, 38.2, 30.5, 26.4, 30.4, 20.2, 29.6, 10.9, 36.2, 22.4, 38.2]
      }],
      chart: {
        type: 'bar',
        height: 306,
        stacked: true,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontWeight: 400,
        fontSize: '8px',
        offsetX: 0,
        offsetY: 0,
        markers: {
          width: 9,
          height: 9,
          radius: 4,
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      grid: {
        show: false,
      },
      colors: colors,
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1

      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return "$ " + val + " thousands"
          }
        }
      }
    };
  }

  onFilter() {
    if (!this.dateRange) {
      this.commonUtilityService.showDanger('Please select any Date');
      return
    }
    this.showClearFilterBtn = true
    this.startDate = this.dateRange.from
    if (this.dateRange.to) {
      this.endDate = this.dateRange.to
    }
    else {
      this.endDate = this.dateRange.from
    }
    this.fetchData()
  }

  onClearFilter() {
    this.showClearFilterBtn = false
    this.dateRange = ''
    this.startDate = ''
    this.endDate = ''
    // this.fetchData()
    this.dateFilter('monthly')
  }

  getTotalBrand() {
    let payload = {
      "shopId": this.activeShopId,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "approval_status": "APPROVED",
    }
    this.productService.getTotalBrand(payload).subscribe(res => {
      let totalBrand = res.totalBrands
      this.statData.push({
        title: 'TOTAL BRANDS',
        value: totalBrand,
        icon: ' ri-product-hunt-line'
      })
    })
  }

}
